import { draftConvertibleNoteStatus } from '../modules/drafts/constants/draftConvertibleNoteStatus';

export default [
  {
    name: draftConvertibleNoteStatus.name.NC_DRAFT,
    value: draftConvertibleNoteStatus.var.NC_DRAFT,
  },
  {
    name: draftConvertibleNoteStatus.name.NC_ACTIVE,
    value: draftConvertibleNoteStatus.var.NC_ACTIVE,
  },
  {
    name: draftConvertibleNoteStatus.name.NC_EXECUTED,
    value: draftConvertibleNoteStatus.var.NC_EXECUTED,
  },
];
